import { Head, Link, useForm } from "@inertiajs/react"
import { AppLayout } from "@/layouts/app-layout"
import { PageHeader } from "@/hooks/use-page-header"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import { Switch } from "@/components/ui/switch"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"

function OrganisationNew() {
  const { data, setData, post, processing } = useForm({
    name: "",
    organisation_type: "promotor",
    is_active: true,
    is_demo: false,
    site_url: "",
    has_exclusivity: true,
    has_lead_gen: false,
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post("/organisations")
  }

  return (
    <>
      <Head title="Nouvelle organisation" />
      <PageHeader title="Nouvelle organisation" back="/organisations" />
      <div className="space-y-6">
        <form onSubmit={handleSubmit}>
          <Card>
            <CardHeader>
              <CardTitle>Informations</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="name">Nom</Label>
                <Input id="name" value={data.name} onChange={(e) => setData("name", e.target.value)} required />
              </div>

              <div className="space-y-2">
                <Label htmlFor="type">Type</Label>
                <Select value={data.organisation_type} onValueChange={(v) => setData("organisation_type", v)}>
                  <SelectTrigger>
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="promotor">Promoteur</SelectItem>
                    <SelectItem value="reseller">Revendeur</SelectItem>
                    <SelectItem value="agency">Agence</SelectItem>
                  </SelectContent>
                </Select>
              </div>

              <div className="space-y-2">
                <Label htmlFor="site_url">Site web</Label>
                <Input id="site_url" value={data.site_url} onChange={(e) => setData("site_url", e.target.value)} />
              </div>

              <div className="flex items-center gap-3">
                <Switch id="is_active" checked={data.is_active} onCheckedChange={(v) => setData("is_active", v)} />
                <Label htmlFor="is_active">Actif</Label>
              </div>

              <div className="flex items-center gap-3">
                <Switch id="is_demo" checked={data.is_demo} onCheckedChange={(v) => setData("is_demo", v)} />
                <Label htmlFor="is_demo">Démo</Label>
              </div>

              <div className="flex items-center gap-3">
                <Switch
                  id="has_exclusivity"
                  checked={data.has_exclusivity}
                  onCheckedChange={(v) => setData("has_exclusivity", v)}
                />
                <Label htmlFor="has_exclusivity">Exclusivité</Label>
              </div>

              <div className="flex items-center gap-3">
                <Switch
                  id="has_lead_gen"
                  checked={data.has_lead_gen}
                  onCheckedChange={(v) => setData("has_lead_gen", v)}
                />
                <Label htmlFor="has_lead_gen">Génération de leads</Label>
              </div>

              <div className="flex justify-end gap-3 pt-4">
                <Button variant="outline" asChild>
                  <Link href="/organisations">Annuler</Link>
                </Button>
                <Button type="submit" disabled={processing}>
                  Créer
                </Button>
              </div>
            </CardContent>
          </Card>
        </form>
      </div>
    </>
  )
}

OrganisationNew.layout = (page: React.ReactNode) => <AppLayout>{page}</AppLayout>

export default OrganisationNew
